export default __webpack_public_path__ + "static/media/facebook.5742b2df.svg";